<template>
  <div>
    <div class="tech-image-upload">
      <div
        class="el-upload el-upload--picture-card d-flex justify-content-center align-items-center"
        :style="`width:${width};height:${height};`"
         @click="chooseImage()"
      >
        <div slot="trigger">
          <i
            v-if="!imageSrc"
            class="el-icon-plus"
            :style="`font-size:${iconSize};font-weight:${iconWeight};`"
          ></i>
        </div>

        <div
          v-if="imageSrc"
          class="tech-image position-relative"
          style="width: 100%; height: 100%"
        >
          <el-image
            style="width: 100%; height: 100%"
            :fit="fit"
            :src="imageSrc"
          ></el-image>
          <div
            class="shadow position-absolute d-flex align-items-center justify-content-center"
          >
            <div>
              <span @click="onImagePreview()" class="mr-2">
                <i class="el-icon-zoom-in"></i
              ></span>
              <span @click="onImageRefresh()" class="mr-2" v-if="!disabled">
                <i class="el-icon-refresh"></i
              ></span>
              <span @click="onImageRemove()" v-if="!disabled">
                <i class="el-icon-delete"></i
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="false" class="imagesViewer" v-viewer="{movable: true}">
      <img :src="imageSrc" />
    </div>

    <ChooseInoutTemplate
      :visible.sync="chooseInoutTemplateVisible"
      url="/sys/sysInoutTemplate/list"
      :templateStatus="['Y']"
      :tableHeight="500"
      :width="'75%'"
      confirm-on-close
      reserve
      @confirm="chooseInoutTemplateConfirm"
    />
  </div>
</template>
<script>
import ChooseInoutTemplate from '../choose-inout-template'
export default {
  components: {
    ChooseInoutTemplate,
  },
  props: {
    templateThumbnailUrl: {type: String, default: () => ''},
    disabled: {type: Boolean, default: false},
    width: {type: String, default: '200px'},
    height: {type: String, default: '200px'},
    iconSize: {type: String, default: '40px'},
    iconWeight: {type: String, default: 'inherit'},
    fit: {type: String, default: 'contain'},
  },
  data() {
    return {flag: false, imageSrc: '', chooseInoutTemplateVisible: false}
  },
  watch: {
    templateThumbnailUrl: {
      handler(val) {
        if (val) {
          this.imageSrc = val
          setTimeout(() => {
            this.flag = true
          }, 0)
          return
        }
        setTimeout(() => {
          this.flag = false
        }, 0)
      },
      immediate: true,
    },
  },
  methods: {
    chooseImage() {
      if (!this.imageSrc) {
        this.chooseInoutTemplateVisible = true
      }
    },
    onImagePreview() {
      if (this.imageSrc) {
        this.viewer = this.$el.querySelector('.imagesViewer').$viewer
        this.viewer.show()
      }
    },
    onImageRemove() {
      this.$emit('updateThumbnail', {
        templateThumbnailUrl: '',
        templateCode: '',
        templateName: '',
      })
      this.imageSrc = ''
    },
    onImageRefresh() {
      this.flag = false
      this.chooseInoutTemplateVisible = true
    },

    chooseInoutTemplateConfirm(data) {
      this.$emit('updateThumbnail', {
        templateThumbnailUrl: data.templateThumbnailUrl,
        templateCode: data.templateCode,
        templateName: data.templateName,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.tech-image:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}
.shadow {
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  line-height: 20px;
  padding: 2px;
}
</style>
